module.exports = __webpack_public_path__ + "img/show-speaker-list.78c5e0c3.jpg";